export default {
  data() {
    return {
      lastSelectedRowId: null,
      lastSelectedRowAction: null
    };
  },

  methods: {
    vgt_RowClick(props, tableName){
      // params.row - row object 
      // params.pageIndex - index of this row on the current page.
      // params.selected - if selection is enabled this argument indicates selected or not
      // params.event - click event
      const currentId = props.row.id;
      if (props.event.shiftKey && this.lastSelectedRowId) {
        this.vgt_selectRange(this.lastSelectedRowId, currentId, tableName);
      } 

      this.lastSelectedRowId = currentId;
      this.lastSelectedRowAction = props.selected;
      const dataRow = this.$refs[tableName].rows.find(r => r.id === props.row.id)
      this.$set(dataRow, 'vgtSelected', this.lastSelectedRowAction) 
    },
    vgt_selectRange(fromId, toId, tableName) {      
      const rows = this.$refs[tableName].processedRows[0].children; // get the currently displayed rows in the table      
      const startIndex = rows.findIndex(r => r.id === fromId);
      const endIndex = rows.findIndex(r => r.id === toId);
      if (startIndex === -1 || endIndex === -1) return;

      const [start, end] = [startIndex, endIndex].sort((a, b) => a - b);  // handle selection direction (up or down in table)

      for (let i = start; i <= end; i++) {
        const dataRow = this.$refs[tableName].rows.find(r => r.id === rows[i].id)
        this.$set(/*rows[i]*/ dataRow, 'vgtSelected', this.lastSelectedRowAction)  
      }
    },
    vgt_SelectAll(props, tableName) {      
      // params.selected - whether the select-all checkbox is checked or unchecked
      // params.selectedRows - all rows that are selected (this page)            
      for (const row of this.$refs[tableName].processedRows[0].children) {
        const dataRow = this.$refs[tableName].rows.find(r => r.id === row.id)
        this.$set(dataRow, 'vgtSelected', props.selected)
      }
    },
    vgt_mounted(tableName) {
      this.$refs[tableName].handleSearch = function() {
        // Don't call resetTable()      
        
        // If in remote mode, still emit
        if (this.mode === 'remote') {
          this.$emit('on-search', { searchTerm: this.searchTerm });
        }

        // Optional: your own filtering logic
      };
    }
  }  
};